import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-700 to-teal-600 text-white">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Colonne 1 - Logo et description */}
          <div className="space-y-6">
            <img 
              src="https://static.readdy.ai/image/f2824006b8e214af3bf77ca05a5a0829/17d80d203e78d22dd9a885a8c832a39a.png" 
              alt="PULSAR FC"
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-teal-100 text-sm leading-relaxed">
              Association d'intérêt général dédiée à la formation civique, l'insertion socioprofessionnelle et l'accompagnement des publics vulnérables.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Colonne 2 - Navigation */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider text-xs">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/qui-sommes-nous" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Nos actions
                </Link>
              </li>
              <li>
                <Link to="/publics-accompagnes" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Publics accompagnés
                </Link>
              </li>
              <li>
                <Link to="/partenariats-impact" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Partenariats &amp; Impact
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Nos formations */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider text-xs">Nos formations</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Formation FLE
                </Link>
              </li>
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Citoyenneté &amp; Laïcité
                </Link>
              </li>
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Sensibilisation numérique
                </Link>
              </li>
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Insertion professionnelle
                </Link>
              </li>
              <li>
                <Link to="/nos-actions" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Accompagnement social
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 4 - Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider text-xs">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-teal-100 text-sm">
                  71 Bis Avenue Jean Jaurès<br />
                  93600 Aulnay-sous-Bois, France
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl flex-shrink-0 mt-0.5"></i>
                <a href="tel:+33650997467" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  +33 6 50 99 74 67
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-xl flex-shrink-0 mt-0.5"></i>
                <a href="mailto:contact@pulsat-pfc.fr" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                  contact@pulsat-pfc.fr
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Barre de copyright */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-100 text-sm">
              © {new Date().getFullYear()} PULSAR FC. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                Mentions légales
              </a>
              <span className="text-teal-100">|</span>
              <a href="#" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                Politique de confidentialité
              </a>
              <span className="text-teal-100">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Éléments décoratifs */}
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-teal-800/30 transform -rotate-12 -translate-x-16 translate-y-16"></div>
      <div className="absolute bottom-0 right-0 w-40 h-40 bg-teal-800/30 transform rotate-12 translate-x-20 translate-y-20"></div>
    </footer>
  );
}
